import {POLYREAL} from './PolyRealTypes'

const initialState = {
    polyReal : false
}

const PolyRealReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case POLYREAL:
            
            return {
                polyReal : action.load
            }
    
        default:
          return state
    }

}

export default PolyRealReducer;